<template>
    <div>
        <v-app>
            <div v-if="auth">
                <v-navigation-drawer :mini-variant.sync="mini"
                                     v-model="$store.state.drawer"
                                     fixed
                                     width="361px"
                                     app
                >

                    <br>
                    <br>
                    <v-list>
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <img v-if="$store.state.userInSession.photo!=null" :src="'data:image/jpeg;base64,'+$store.state.userInSession.photo">
                                <img v-if="$store.state.userInSession.photo==null" src="./assets/inscora-logo.jpg">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Usuario: {{this.$store.state.idUser}}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-btn
                                    v-if="mini "
                                    @click.stop="mini = !mini"
                                    color="black"
                                    fixed
                                    class="noBackgorun"
                                    style="left:50%;"
                                    flat
                                    fab
                            >
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                        </v-list-tile>
                        <v-list-group v-if="isAdmin"
                                prepend-icon="account_circle"
                                value="true"
                        >
                            <v-list-tile slot="activator">
                                <v-list-tile-title>Actividades OHS</v-list-tile-title>
                            </v-list-tile>
                            <v-list-group v-if="isAdmin"
                                          v-for="item in itemsActividades"
                                          :key="item.title"
                                          v-model="item.active"
                                          :prepend-icon="item.action"
                                          no-action
                                          :append-icon="item.appendIcon"
                                          sub-group>

                                <template v-slot:activator>
                                    <v-list-tile router :to="item.route">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>

                                <v-list-tile
                                        v-if="isAdmin"
                                        v-for="subItem in item.items"
                                        :key="subItem.title"
                                        router :to="subItem.route"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-icon>{{ subItem.action }}</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list-group>
                        </v-list-group>
                      <v-list-group v-if="isAdminCompany"
                          prepend-icon="account_circle"
                          value="true"
                      >
                        <v-list-tile slot="activator">
                          <v-list-tile-title>Actividades OHS</v-list-tile-title>
                        </v-list-tile>
                        <v-list-group v-if="isAdminCompany"
                                      v-for="item in itemsActividadesAdminCompany"
                                      :key="item.title"
                                      v-model="item.active"
                                      :prepend-icon="item.action"
                                      no-action
                                      :append-icon="item.appendIcon"
                                      sub-group>

                          <template v-slot:activator>
                            <v-list-tile router :to="item.route">
                              <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile
                              v-if="isAdminCompany"
                              v-for="subItem in item.items"
                              :key="subItem.title"
                              router :to="subItem.route"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <v-icon>{{ subItem.action }}</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list-group>
                      </v-list-group>
                    </v-list>
                    <v-list>
                        <v-list-group
                                prepend-icon="account_circle"
                                value="true"
                        >
                            <v-list-tile slot="activator">
                                <v-list-tile-title>EHR (Electronic Health Records)</v-list-tile-title>
                            </v-list-tile>
                            <v-list-group v-if="isAdmin"
                                          v-for="item in items"
                                          :key="item.title"
                                          v-model="item.active"
                                          :prepend-icon="item.action"
                                          no-action
                                          :append-icon="item.appendIcon"
                                          sub-group>

                                <template v-slot:activator>
                                    <v-list-tile router :to="item.route">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>

                                <v-list-tile
                                        v-if="isAdmin"
                                        v-for="subItem in item.items"
                                        :key="subItem.title"
                                        router :to="subItem.route"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-icon>{{ subItem.action }}</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list-group>
                            <v-list-group v-if="isAdminCompany"
                                          v-for="item in itemsCompany"
                                          :key="item.title"
                                          v-model="item.active"
                                          :prepend-icon="item.action"
                                          no-action
                                          :append-icon="item.appendIcon"
                                          sub-group>

                                <template v-slot:activator>
                                    <v-list-tile router :to="item.route">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>

                                <v-list-tile
                                        v-if="isAdminCompany"
                                        v-for="subItem in item.items"
                                        :key="subItem.title"
                                        router :to="subItem.route"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-icon>{{ subItem.action }}</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list-group>
                        </v-list-group>
                    </v-list>
                </v-navigation-drawer>
                <!-- Header -->
                <v-toolbar
                        v-if="$store.state.toolbar!=null?$store.state.toolbar:true"
                        dark
                        color="nav_background_color"
                        dense
                        fixed
                        clipped-left
                        app
                >
                    <v-toolbar-side-icon @click.stop="$store.state.drawer = !$store.state.drawer"></v-toolbar-side-icon>
                    <v-toolbar-title>OHS(OCCUPATIONAL HEALTH SERVICES)</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn icon @click.stop="dialogPassword = true">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <!--          <v-btn icon @click.stop="menu = true" >-->
                    <!--            <v-icon >more_vert</v-icon>-->
                    <!--            <v-menu v-model="menu" offset-y >-->
                    <!--             <v-list>-->
                    <!--                <v-list-tile>-->
                    <!--                  <v-list-tile-title><div @click.stop="dialogPassword = true">Cambiar Contraseña</div></v-list-tile-title>-->
                    <!--                </v-list-tile>-->
                    <!--              </v-list>-->
                    <!--            </v-menu>-->
                    <!--          </v-btn>-->
                    <v-btn icon @click="closeSession">
                        <v-icon>exit_to_app</v-icon>
                    </v-btn>
                </v-toolbar>

                <!-- Router Components-->
                <v-content>
                    <router-view/>
                </v-content>

                <!-- Generic Error -->
                <v-dialog v-model="this.$store.state.dialogError" max-width="500px">
                    <v-card>
                        <v-card-title>
                            Error en la aplicación
                        </v-card-title>
                        <v-card-text>
                            Detalle: {{this.$store.state.dialogErrorMessage}}
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" flat @click.stop="closeError">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!-- Dialog Password -->
                <v-dialog v-model="dialogPassword" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span>Cambiar Contraseña</span>

                            <v-form v-model="valid">
                                Ingrese su nueva contraseña y la confirmación de la misma
                                <v-text-field prepend-icon="lock" :rules="newPasswordRules" name="Nueva Contraseña"
                                              label="Nueva Contraseña" type="password"
                                              v-model="newPassword"></v-text-field>
                                <v-text-field prepend-icon="lock" :rules="newPasswordRules"
                                              name="Confirme su Nueva Contraseña" label="Confirme su Nueva Contraseña"
                                              type="password" v-model="newPasswordConfirmation"
                                              v-on:keyup.enter="changePassword"></v-text-field>
                            </v-form>
                        </v-card-title>
                        <v-card-actions>
                            <v-btn color="primary" flat :disabled="!valid" @click="changePassword">Cambiar</v-btn>
                            <v-btn color="primary" flat @click.stop="dialogPassword=false" @click="cleanPasswordChange">
                                Cancelar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-alert v-model="alert" color="error" dismissible>
                        {{error}}
                    </v-alert>
                </v-dialog>
            </div>
            <!-- No log In -->
            <div v-if="!auth">
                <router-view/>
                <v-dialog v-model="this.$store.state.dialogError" max-width="500px">
                    <v-card>
                        <v-card-title>
                            {{this.$store.state.dialogErrorHeader}}
                        </v-card-title>
                        <v-card-text>
                            Detalle: {{this.$store.state.dialogErrorMessage}}
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" flat @click.stop="closeError">Cerrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
            <div v-if="this.$store.state.progress" class="loading">
                <div class="progressIcon" style="">
                    <v-progress-circular
                            indeterminate
                            color="white"
                    ></v-progress-circular>
                </div>
                <div class="messageLoading">Por favor espere un momento...</div>
            </div>
        </v-app>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mini: false,
                drawer: false,
                fixed: false,
                menu: false,
                admins: [
                    ['Management', 'people_outline'],
                    ['Settings', 'settings']
                ],
                cruds: [
                    ['Create', 'add'],
                    ['Read', 'insert_drive_file'],
                    ['Update', 'update'],
                    ['Delete', 'delete']
                ],
                itemsActividades: [
                    {
                        action: 'settings_applications',
                        title: 'Configuración',
                        items: [
                            // { action: 'settings_applications', title: 'Configuración', route: 'start4', rol: 'admin'},
                            {action: 'note_add', title: 'Sistema', route: 'activityConfiguration', rol: 'admin'},
                            {action: 'perm_identity', title: 'Clientes', route: 'activity-company', rol: 'user'},
                        ]
                    },
                    {
                        action: 'play_arrow',
                        title: 'Ejecución',
                        items: [
                            // { action: 'settings_applications', title: 'Configuración', route: 'start4', rol: 'admin'},
                            {action: 'playlist_add', title: 'Creación actividad', route: 'activity', rol: 'admin'},
                            {action: 'playlist_play', title: 'Ejecución actividad', route: 'activityList', rol: 'admin'},
                        ]
                    },
                    {
                      action: 'file_download',
                      title: 'Reportes',
                      items: [
                        {action: 'format_list_bulleted', title: 'Reporte actividad', route: 'activityExportProcess', rol: 'admin'},
                      ]
                    },
                ],
              itemsActividadesAdminCompany: [
                {
                  action: 'play_arrow',
                  title: 'Ejecución',
                  items: [
                    {action: 'playlist_play', title: 'Ejecución actividad', route: 'activityList', rol: 'admin'},
                  ]
                },
              ],
                items: [
                    {
                        action: 'file_copy',
                        title: 'Datos',
                        items: [
                            {action: 'perm_identity', title: 'Clientes', route: 'company', rol: 'user'},
                            {action: 'note_add', title: 'Pacientes', route: 'patient', rol: 'admin'},

                        ]
                    },
                    {
                        action: 'folder',
                        title: 'Administración',
                        items: [
                            // { action: 'settings_applications', title: 'Configuración', route: 'start4', rol: 'admin'},
                            {action: 'supervised_user_circle', title: 'Usuarios', route: 'user', rol: 'admin'},
                            {action: 'accessibility', title: 'Perfiles', route: 'role', rol: 'admin'},
                            {action: 'eco', title: 'Procedimiento', route: 'procedure', rol: 'admin'},
                            {
                                action: 'description',
                                title: 'Examenes laboratorio',
                                route: 'laboratoryExam',
                                rol: 'admin'
                            },
                            // { action: 'invert_colors',title: 'Laboratorio clientes', route: 'start4', rol: 'admin' },
                            // { action: 'class', title: 'Diagnósticos', route: 'start5', rol: 'admin' },
                            {action: 'face', title: 'Vacunas', route: 'vaccine', rol: 'admin'},
                            {action: 'all_inbox', title: 'Tipos y Elementos', route: 'type', rol: 'admin'},
                            {action: 'person', title: 'Proveedores', route: 'provider', rol: 'admin'},
                            {action: 'book', title: 'Catálogos', route: 'catalog', rol: 'admin'}
                        ]
                    },
                    {
                        action: 'wb_sunny',
                        title: 'Emergencia',
                        items: [
                            {action: 'supervised_user_circle', title: 'Ficha Covid', route: 'covid', rol: 'admin'},
                            {action: 'add_alert', title: 'Alarma Covid', route: 'covidPatient', rol: 'admin'},
                            {
                                action: 'settings_applications',
                                title: 'Configuraciones Covid',
                                route: 'covidConfiguration',
                                rol: 'admin'
                            }                            
                        ]
                    },

                    {
                        action: 'file_download',
                        title: 'Herramientas',
                        items: [
                            // { action: 'settings_applications', title: 'Configuración', route: 'start4', rol: 'admin'},
                            {action: 'create', title: 'Crear proceso', route: 'exportProcess', rol: 'admin'},
                            {
                                action: 'format_list_bulleted',
                                title: 'Procesos exportar',
                                route: 'exportProcessList',
                                rol: 'admin'
                            },
                            {action: 'track_changes', title: 'Auditoría', route: 'auditOHS', rol: 'admin'},
                            {action: 'cloud_download', title: 'Matriz Riesgo / Grupo Homogénio', route: 'matrizRiegoGrupoHomogenioReport', rol: 'admin'},
                            {action: 'article', title: 'Reporte vacunas', route: 'reporteVacunas', rol: 'admin'},
                            {action: 'add_alert', title: 'Reporte alertas', route: 'reporteAlertas', rol: 'admin'},
                            {action: 'backup_table', title: 'Reporte hojas abiertas', route: 'reporteHojasAbiertas', rol: 'admin'}
                        ]
                    },
                    // {
                    //   action: 'menu_book',
                    //   title: 'Documental',
                    //   items: [
                    //     {action: 'check', title: 'Aprobar laboratorio', route: 'start6', rol: 'admin' },
                    //     {action: 'post_add', title: 'Crear orden de examenes', route: 'start7', rol: 'admin'  },
                    //     {action: 'notes', title: 'Ordenes de examenes' , route: 'start8', rol: 'admin'}
                    //   ]
                    // },
                    // {
                    //   action: 'insert_chart',
                    //   title: 'Reportes',
                    //   items: [
                    //     {action: 'add_alert', title: 'Alertas', route: 'start9', rol: 'admin'  },
                    //     {action: 'airplay', title: 'Auditoría', route: 'start10', rol: 'admin' },
                    //     {action: 'dashboard', title: 'Estadística', route: 'start11', rol: 'admin'  },
                    //     {action: 'trending_flat',  title: 'Tracking', route: 'start12', rol: 'admin' },
                    //     {action: 'face', title: 'Vacunas',  route: 'start13', rol: 'admin' },
                    //     {action: 'view_module', title: 'Matriz riesgo', route: 'start14', rol: 'admin' },
                    //     {action: 'view_agenda', title: 'Grupo homogéneo',  route: 'start15', rol: 'admin'}
                    //   ]
                    // },
                    // {
                    //   action: 'build',
                    //   title: 'Herramientas',
                    //   items: [
                    //     { title: 'Hojas de ruta' },
                    //     { title: 'Exportar datos' },
                    //     { title: 'Procesos exportar' },
                    //     { title: 'Exp. Cuest. PROESSAT' },
                    //     { title: 'Exp. Guías PROESSAT' },
                    //     { title: 'Calculador ATP III' }
                    //   ]
                    // },
                    // {
                    //   action: 'dvr',
                    //   title: 'Sistema',
                    //   items: [
                    //     { action: 'vpn_key',title: 'Cambiar contraseña' },
                    //     { action: 'exit_to_app', title: 'Cerrar sesión' }
                    //   ]
                    // }
                ],
                itemsCompany: [
                    {
                        action: 'home',
                        title: 'Inicio',
                        route: 'start',
                        rol: 'user',
                        appendIcon: null
                    },
                    {
                        action: 'file_copy',
                        title: 'Datos',
                        items: [
                            {action: 'note_add', title: 'Pacientes', route: 'patient', rol: 'admin'},

                        ]
                    },
                    {
                        action: 'wb_sunny',
                        title: 'Emergencia',
                        items: [
                            {action: 'supervised_user_circle', title: 'Ficha Covid', route: 'covid', rol: 'admin'},
                            {action: 'add_alert', title: 'Alarma Covid', route: 'covidPatient', rol: 'admin'},
                        ]
                    },


                ],


                miniVariant: false,
                right: true,
                rightDrawer: false,
                title: 'Vuetify.js',
                dialogPassword: false,
                newPassword: '',
                newPasswordConfirmation: '',
                error: '',
                alert: false,
                valid: false,
                newPasswordRules: [
                    v =>
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(v) ||
                        'La constraseña deberá ser mínimo de 8 caracteres, contener mínimo 1 letra mayúscula y 1 carácter numérico'
                ]
            };
        },
        computed: {
            auth() {
                return this.$store.getters.isAuthenticated;
            },
            fechaActual() {
                var meses = new Array(
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre'
                );
                var f = new Date();
                return (
                    f.getDate() + ' de ' + meses[f.getMonth()] + ' del ' + f.getFullYear()
                );
            },
            isAdmin() {
                for (var i = 0; i < this.$store.state.roles.length; i++) {
                    if (this.$store.state.roles[i] === 'ROLE_ADMIN') {
                        return true;
                    }
                }
                return false;
            },
            isAdminCompany() {
                for (var i = 0; i < this.$store.state.roles.length; i++) {
                    if (this.$store.state.roles[i] === 'ROLE_ADMIN_COMPANY') {
                        return true;
                    }
                }
                return false;
            },
            isUser() {
                for (var i = 0; i < this.$store.state.roles.length; i++) {
                    if (this.$store.state.roles[i] === 'ROLE_USER') {
                        return true;
                    }
                }
                return false;
            }
        },
        methods: {
            closeSession() {
                sessionStorage.setItem('id_token', null);
                this.$store.state.authenticated = false;
                this.$router.push('/login');
                let state = this.$store.state;
                let newState = {};
                Object.keys(state).forEach(key => {
                    newState[key] = null; // or = initialState[key]
                });
                this.$store.replaceState(newState);

            },
            closeError() {
                this.$store.state.dialogErrorMessage = "Se ha presentado un error en el aplicativo. Vuelva a intentarlo más tarde"
                this.$store.state.dialogError = false;
            },
            changePassword() {
                if (this.checkNewPassword()) {
                    this.$store.dispatch('changePassword', this.newPassword).then(
                        response => {
                            this.cleanPasswordChange();
                        },
                        error => {
                            this.$store.state.dialogError = true;
                        }
                    );
                    this.dialogPassword = false;
                }
            },
            checkNewPassword() {
                if (this.newPassword != this.newPasswordConfirmation) {
                    this.error = 'La nueva contraseña no coincide con la confirmación.';
                    this.alert = true;
                    return false;
                }
                return true;
            },
            cleanPasswordChange() {
                this.newPassword = '';
                this.newPasswordConfirmation = '';
                this.dialogPassword = false;
                this.alert = false;
                this.valid = false;
            }
        },
        beforeCreate() {
            this.$store.state.changePassword = this.$route.query.changePassword;
        },
        name: 'App'
    };
</script>

<style>
    h3 {
        margin: 1rem;
    }

    .fechaDiv {
        padding-top: 5px;
        font-weight: bold;
        text-align: center;
        font-size: 12px;
    }

    .userDiv {
        padding-top: 5px;
        font-weight: bold;
        text-align: center;
        font-size: 14px;
    }

    .changePassDiv {
        padding-top: 5px;
        text-align: center;
        font-size: 12px;
        padding-bottom: 5px;
    }

    .loading {
        background-color: #000;
        width: 100%;
        height: 100%;
        opacity: 0.6;
        position: absolute;
        z-index: 3;
    }

    .progressIcon {
        padding-top: 20%;
        text-align: center;
        z-index: 1;
    }

    .messageLoading {
        text-align: center;
        color: white;
        z-index: 1;
    }

    .noBackgorun:before {
        opacity: .0;
    }

    .container{
        max-width: 100%;
    }

    @media print
    {
        body {-webkit-print-color-adjust: exact;}

        .no-print, .no-print *
        {
            display: none !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue